/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import deviceGroupFieldsetTemplate from './device-group-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function DeviceGroupDirective($compile, $templateCache, $translate, toast) {
    var linker = function (scope, element) {
        var template = $templateCache.get(deviceGroupFieldsetTemplate);
        element.html(template);

        scope.onapplicationIdCopied = function() {
            toast.showSuccess($translate.instant('device-group.id-copied-message'), 750, angular.element(element).closest(".toast-parent"), 'bottom left');
        };

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            deviceGroup: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/device-group/device-group.directive.js